import { useEffect } from 'react'
import { Navigate } from 'react-router-dom'
import { useUser } from '@/hooks/use-user'

// Root '/' for a logged-IN visitor. The API serves the static marketing
// landing to logged-out visitors *before* React loads (the "/" cookie branch
// in Program.cs), so this component normally only runs for a logged-in user —
// send them to their dashboard (/user/{id}, the migrated home).
//
// The no-user case is the rare expired-cookie edge: the cookie was present so
// the server served the SPA, but the token is dead and the user didn't resolve.
// Bounce to the public landing (full-page nav — it's a static file, not a route).
export function RootRedirect() {
  const { user } = useUser()
  useEffect(() => {
    if (!user) window.location.replace('/landing.html')
  }, [user])
  return user ? <Navigate to={`/user/${user.id}`} replace /> : null
}
